import React from 'react';

import { FormattedCurrencyContainer } from '../../../../../components/formatted-currency/container';
import { BillingPlanPropType } from '../../../../../prop-types/billing-plan';
import { USD, AUD, EUR, GBP } from '../../../../../constants/currency-codes';
import { useGetSubscriptionCurrencyCode } from '../../hooks/use-get-subscription-currency-code';
import { BillingPlanIds } from '../../../../../enums/billing-plan-ids';

// TODO: burn this down in a fire and data drive this in a follow up
const perLabelFeeMapMap = {
  [BillingPlanIds.SSStartupANZQ12023]: {
    [USD]: 0.22,
    [AUD]: 0.33,
  },
  [BillingPlanIds.SSAccelerateANZQ12023]: {
    [USD]: 0.13,
    [AUD]: 0.2,
  },
  [BillingPlanIds.SSScaleANZQ12023]: {
    [USD]: 0.08,
    [AUD]: 0.12,
  },
  [BillingPlanIds.SSEnterpriseANZQ12023]: {
    [USD]: 0.05,
    [AUD]: 0.07,
  },
  [BillingPlanIds.SSHighVolumeANZQ22023]: {
    [USD]: 0.05,
    [AUD]: 0.08,
  },

  // EU
  [BillingPlanIds.SSEUStartupBYOA2023Q2]: {
    [EUR]: 0.05,
    [GBP]: 0.05,
  },
  [BillingPlanIds.SSEUAccelerateBYOA2023Q2]: {
    [EUR]: 0.04,
    [GBP]: 0.04,
  },
  [BillingPlanIds.SSEUScaleBYOA2023Q2]: {
    [EUR]: 0.03,
    [GBP]: 0.03,
  },

  // UK
  [BillingPlanIds.SSUKStartupBYOA2023Q2]: {
    [EUR]: 0.05,
    [GBP]: 0.05,
  },
  [BillingPlanIds.SSUKAccelerateBYOA2023Q2]: {
    [EUR]: 0.04,
    [GBP]: 0.04,
  },
  [BillingPlanIds.SSUKScaleBYOA2023Q2]: {
    [EUR]: 0.03,
    [GBP]: 0.03,
  },
};

export const getPerLabelFee = (billingPlanId, currencyCode) => {
  return perLabelFeeMapMap[billingPlanId]?.[currencyCode];
};

export const PerLabelFee = ({ plan }) => {
  const currencyCode = useGetSubscriptionCurrencyCode();
  const perLabelFee = getPerLabelFee(plan.billingPlanId, currencyCode);

  if (!perLabelFee) {
    return <>-</>;
  }

  return <FormattedCurrencyContainer currencyCode={currencyCode} fractionDigits={2} value={perLabelFee} />;
};

PerLabelFee.propTypes = {
  plan: BillingPlanPropType.isRequired,
};
